import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {filter, map} from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import {AccountService} from "../../services";
import {NotificationsHistory} from "../model/notificationsHistory";

@Injectable({ providedIn: 'root' })
export class NotificationHistoryService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    getAll(id: string, offset: number, limit: number) {

        return this.http.get<NotificationsHistory>(`${environment.apiEndpoint}/v1/communication-history?filters[user]=` + id + `&offset=`+offset+`&limit=`+limit, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }
}
